import React from "react";
import { Text, View } from "@react-pdf/renderer";
import PrintApplicationStyles from "../PrintApplicationStyles";
import { formatPrintDate } from "../formatPrintDate";

const PrintSection5 = ({ section5 }) => {
  return (
    <>
      <Text break style={PrintApplicationStyles.sectionheader}>
        Section 5 – Accountant Details
      </Text>
      <Text style={PrintApplicationStyles.subcontent}>
        5.1 Accountant details
      </Text>
      <View style={PrintApplicationStyles.tableRow}>
        <View style={PrintApplicationStyles.inputSection}>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Do you currently have an accountant?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section5?.hasAccountant === true
                  ? "Yes"
                  : section5?.hasAccountant === false
                    ? "No"
                    : section5?.hasAccountant === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>Title</Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section5?.title || ""}</Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>Surname</Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section5?.surname || ""}</Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>Initials</Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section5?.initials || ""}</Text>
            </View>
          </View>

          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>Address</Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section5?.address || ""}</Text>
            </View>
          </View>

          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Telephone Number
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section5?.telephone || ""}</Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>Email Address</Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section5?.emailAddress || ""}</Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              How long has the above been your accountant?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {formatPrintDate(section5?.from)}
              </Text>
            </View>
          </View>
        </View>
      </View>
      <Text style={PrintApplicationStyles.subcontent}>Trade Referees</Text>
      <Text style={PrintApplicationStyles.subcontent}>
        If you have been self-employed within the last 3 years in an industry
        which is not within the financial services sector, please provide the
        names and addresses of 2 Trade Referees who can verify your trading
        activities
      </Text>

      {section5?.tradeReferees &&
      Object.keys(section5?.tradeReferees).length > 0 ? (
        Object.values(section5?.tradeReferees).map((referee, index) => (
          <View key={index}>
            <Text style={PrintApplicationStyles.subcontent}>
              Trade Referee {index + 1}
            </Text>
            <View style={PrintApplicationStyles.tableRow}>
              <View style={PrintApplicationStyles.inputSection}>
                <View style={PrintApplicationStyles.inputRow}>
                  <Text style={PrintApplicationStyles.inputLabel}>
                    Trade Name
                  </Text>
                  <View style={PrintApplicationStyles.inputBox}>
                    <Text>{referee?.tradeName || ""}</Text>
                  </View>
                </View>
                <View style={PrintApplicationStyles.inputRow}>
                  <Text style={PrintApplicationStyles.inputLabel}>
                    Company Name
                  </Text>
                  <View style={PrintApplicationStyles.inputBox}>
                    <Text>{referee?.companyName || ""}</Text>
                  </View>
                </View>
                <View style={PrintApplicationStyles.inputRow}>
                  <Text style={PrintApplicationStyles.inputLabel}>Address</Text>
                  <View style={PrintApplicationStyles.inputBox}>
                    <Text>{referee?.tradeAddress || ""}</Text>
                  </View>
                </View>
                <View style={PrintApplicationStyles.inputRow}>
                  <Text style={PrintApplicationStyles.inputLabel}>
                    Email Address
                  </Text>
                  <View style={PrintApplicationStyles.inputBox}>
                    <Text>{referee?.tradeEmailAddress || ""}</Text>
                  </View>
                </View>
                <View style={PrintApplicationStyles.inputRow}>
                  <Text style={PrintApplicationStyles.inputLabel}>
                    Phone Number
                  </Text>
                  <View style={PrintApplicationStyles.inputBox}>
                    <Text>{referee?.refereePhoneNumber || ""}</Text>
                  </View>
                </View>
                <View style={PrintApplicationStyles.inputRow}>
                  <Text style={PrintApplicationStyles.inputLabel}>
                    Dates of your trading activities to be covered
                  </Text>
                  <View style={PrintApplicationStyles.inputBox}>
                    <Text>{referee?.datesOfTradingActivities || ""}</Text>
                  </View>
                </View>
              </View>
            </View>
          </View>
        ))
      ) : (
        <Text>No trade referees provided.</Text>
      )}
      <Text style={PrintApplicationStyles.subcontent}>Personal Referees</Text>
      <Text style={PrintApplicationStyles.subcontent}>
        Please note these Personal Referees cannot be family members or
        individuals with a relationship to Rosemount.
      </Text>
      <Text style={PrintApplicationStyles.subcontent}>
        If you have any gaps in employment within the last 3 years, please
        provide the names and addresses of 2 Personal Referees.
      </Text>
      {section5?.personalReferees &&
      Object.keys(section5?.personalReferees).length > 0 ? (
        Object.values(section5?.personalReferees).map((referee, index) => (
          <View key={index}>
            <Text style={PrintApplicationStyles.subcontent}>
              Personal Referee {index + 1}
            </Text>
            <View style={PrintApplicationStyles.tableRow}>
              <View style={PrintApplicationStyles.inputSection}>
                <View style={PrintApplicationStyles.inputRow}>
                  <Text style={PrintApplicationStyles.inputLabel}>Name</Text>
                  <View style={PrintApplicationStyles.inputBox}>
                    <Text>{referee?.refereeName || ""}</Text>
                  </View>
                </View>

                <View style={PrintApplicationStyles.inputRow}>
                  <Text style={PrintApplicationStyles.inputLabel}>Address</Text>
                  <View style={PrintApplicationStyles.inputBox}>
                    <Text>{referee?.refereeAddress || ""}</Text>
                  </View>
                </View>
                <View style={PrintApplicationStyles.inputRow}>
                  <Text style={PrintApplicationStyles.inputLabel}>
                    Email Address
                  </Text>
                  <View style={PrintApplicationStyles.inputBox}>
                    <Text>{referee?.refereeEmailAddress || ""}</Text>
                  </View>
                </View>

                <View style={PrintApplicationStyles.inputRow}>
                  <Text style={PrintApplicationStyles.inputLabel}>
                    Phone Number
                  </Text>
                  <View style={PrintApplicationStyles.inputBox}>
                    <Text>{referee?.refereePhoneNumber || ""}</Text>
                  </View>
                </View>
                <View style={PrintApplicationStyles.inputRow}>
                  <Text style={PrintApplicationStyles.inputLabel}>
                    Dates of unemployment
                  </Text>
                  <View style={PrintApplicationStyles.inputBox}>
                    <Text>{referee?.datesOfUnemployment || ""}</Text>
                  </View>
                </View>
                <View style={PrintApplicationStyles.inputRow}>
                  <Text style={PrintApplicationStyles.inputLabel}>
                    Relationship with next of kin
                  </Text>
                  <View style={PrintApplicationStyles.inputBox}>
                    <Text>{referee?.relationshipToReferee || ""}</Text>
                  </View>
                </View>
              </View>
            </View>
          </View>
        ))
      ) : (
        <Text>No personal referees provided.</Text>
      )}
    </>
  );
};

export default PrintSection5;
